import React, { useCallback, useState } from "react";
import SelectAttendeesDialog from "./SelectAttendeesDialog";
import { components } from "../../../../api/spec";

interface SelectAttendeesResult {
  memberIds: string[];
  message: string;
}

type EventAttendeeSummarySchema =
  components["schemas"]["EventAttendeeSummarySchema"];

// eslint-disable-next-line import/prefer-default-export
export const useSelectAttendeesDialog = () => {
  const [show, setShow] = useState<boolean>(false);
  const [attendees, setAttendees] = useState<
    EventAttendeeSummarySchema[] | null
  >(null);

  const [promiseResolve, setPromiseResolve] = useState<
    ((result: SelectAttendeesResult | null) => void) | null
  >(null);

  const selectAttendees = useCallback(
    async (inputAttendees: EventAttendeeSummarySchema[]) => {
      setShow(true);
      setAttendees(inputAttendees);

      return new Promise<SelectAttendeesResult | null>((resolve) => {
        // NOTE: If you pass a callback to setState, React will call that callback,
        // so that's why this is wrapped in a pointless arrow function.
        setPromiseResolve(() => resolve);
      });
    },
    [],
  );

  return {
    dialog: show ? (
      <SelectAttendeesDialog
        attendees={attendees}
        onConfirm={(result: SelectAttendeesResult) => {
          setShow(false);
          promiseResolve?.(result);
        }}
        onCancel={() => {
          setShow(false);
          promiseResolve?.(null);
        }}
      />
    ) : null,
    selectAttendees,
  };
};
